// logoutUser.js
import { EventBus } from '@/utils/eventBus.js';

export function logoutUser() {
  // Token und Ablaufdatum aus dem Local Storage entfernen.
  // Der api-Interceptor liest das Token bei jedem Request frisch aus dem
  // localStorage, daher muss kein Header manuell entfernt werden.
  localStorage.removeItem('token');
  localStorage.removeItem('tokenExpire');

  // Event auslösen, um die Authentifizierung in App.vue neu zu prüfen
  EventBus.emit('recheck-auth');

  // KEIN window.location.reload() hier mehr!
  // App.vue leitet zur Login-Seite weiter und der Zustand wird dort aktualisiert.
}
